var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.058 2.988a1.8 1.8 0 0 1 2.52.288l1.434 1.792a1.8 1.8 0 0 1-.253 2.507L6.345 17.087l-5.318.886.901-5.41zm1.271 1.288a.2.2 0 0 0-.28-.032l-1.658 1.309 1.786 2.091 1.558-1.298a.2.2 0 0 0 .028-.278zm-1.381 4.393-1.814-2.124-8.73 6.891-.43 2.59 2.68-.446z",
  clipRule: "evenodd"
})));
export default SvgEdit;